/* Art-direction v2 (homepage + product pages). Tints the product plate with the
   chosen flavor's brand color. Reads the selector's own flavor radios; never
   touches the variant, price, plan, or cart logic. On the PDP it also tells the
   plate whether the main image is a render (multiply onto the tint) or a photo /
   facts panel (plain white). Inert if no selector is present. */
(function () {
  if (!document.body.classList.contains('v2')) return;
  var selector = document.querySelector('[data-selector]');
  if (!selector) return;
  var media = selector.querySelector('.notg-selector__media') || selector.querySelector('.pdp__main');
  if (!media) return;

  /* Brand flavor accents (light values from the 2026 palette), lightened a touch
     so the dark-green pack keeps contrast on the plate. Chocolate runs darker on
     purpose (Gabe 8/27): it has to read as chocolate and separate from cinnamon. */
  var TINTS = {
    vanilla: '#ead6b4',
    chocolate: '#96604a',
    cinnamon: '#f0c9a7',
    mixed: '#dcd3c2',
    variety: '#dcd3c2'
  };

  function currentFlavor() {
    var pane = selector.querySelector('[data-pane]:not([hidden])') || selector;
    var fieldsets = pane.querySelectorAll('[data-option-position]');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && /flavor/i.test(legend.textContent)) {
        var c = fieldsets[i].querySelector('input:checked');
        return c ? c.value : '';
      }
    }
    var checked = pane.querySelector('[data-option-position] input:checked');
    return checked ? checked.value : '';
  }

  function apply() {
    var f = (currentFlavor() || '').toLowerCase();
    var key = Object.keys(TINTS).find(function (k) { return f.indexOf(k) !== -1; });
    media.style.setProperty('--flavor-tint', key ? TINTS[key] : '#e9e1d1');
  }

  selector.addEventListener('change', function (e) {
    if (e.target && (e.target.matches('[data-option-input]') || e.target.matches('[data-line-input]'))) apply();
  });
  apply();

  /* PDP only: render vs photo. Renders are the per-variant images (variant media
     and the SKU-named theme assets); anything else the gallery shows (lifestyle,
     facts panels) gets the white plate. */
  var mainImg = selector.querySelector('.pdp__main-img');
  if (!mainImg || !media.classList.contains('pdp__main')) return;

  var section = selector.closest('.shopify-section') || document;
  var renders = {}, cutUrls = {}, swapTo = {}, imageMap = {};
  function norm(u) {
    return String(u || '').replace(/^https?:/, '').replace(/[?&](v|width)=[^&]*/g, '');
  }
  function collect(sel, fn) {
    var el = section.querySelector(sel);
    if (!el) return;
    try { fn(JSON.parse(el.textContent)); } catch (e) {}
  }
  collect('[data-image-map]', function (m) {
    imageMap = m || {};
    Object.keys(imageMap).forEach(function (k) { if (imageMap[k]) renders[norm(imageMap[k])] = 1; });
  });
  /* Variant media are white-ground renders; the theme carries transparent
     cutout twins as assets (vegan/cinnamon under the plain SKU name, whey
     under SKU_v2cut so the PDP keeps the old-label art while the plain whey
     assets stay rebrand-style for the homepage). Swap the main image to the
     cutout so the flavor plate needs no blend trick. */
  var skuKeys = Object.keys(imageMap).sort(function (a, b) { return b.length - a.length; });
  collect('[data-variant-data]', function (vs) {
    (vs || []).forEach(function (v) {
      if (!v || !v.image) return;
      renders[norm(v.image)] = 1;
      var fname = v.image.split('/').pop();
      for (var i = 0; i < skuKeys.length; i++) {
        var k = skuKeys[i];
        if ((fname.indexOf(k + '.') === 0 || fname.indexOf(k + '_') === 0) && imageMap[k]) {
          var target = imageMap[k];
          if (/^W[CVM]\d/.test(k)) target = target.replace(k + '_', k + '_v2cut_');
          swapTo[norm(v.image)] = target;
          cutUrls[norm(target)] = 1;
          break;
        }
      }
    });
  });

  function judge() {
    var src = mainImg.getAttribute('src') || '';
    var n = norm(src);
    if (swapTo[n]) {
      media.classList.remove('is-photo');
      mainImg.removeAttribute('srcset');
      mainImg.setAttribute('src', swapTo[n]);
      return;
    }
    if (cutUrls[n]) {
      media.classList.add('is-cut');
      media.classList.remove('is-photo');
      return;
    }
    media.classList.remove('is-cut');
    media.classList.toggle('is-photo', !renders[n]);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(judge).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
  }
  mainImg.addEventListener('load', judge);
  judge();
})();
